<mat-card>
  <mat-card-title [innerText]="'MAIN_APP_ADRESSES.adresseErfassen' | translate"></mat-card-title>
  <mat-card-content [formGroup]="formGroupAdresse">
    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.name" | translate }}</mat-label>
        <input matInput formControlName="fldAdressName" (keyup)="onNameChange($event)" required />
      </mat-form-field>
      <mat-form-field>
        <mat-label> {{ "MAIN_APP_ADRESSES.vorname" | translate }} </mat-label>
        <input matInput formControlName="fldAdressVorname" (keyup)="onVornameChange($event)" />
      </mat-form-field>
    </span>

    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.anrede" | translate }}</mat-label>
        <mat-select formControlName="fldAdressAnrede">
          <mat-option *ngFor="let anrede of anreden" [value]="anrede.anrede" >
            {{anrede.anrede}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.briefanrede" | translate }}</mat-label>
        <mat-select formControlName="fldAdressBriefanrede">
          <mat-option *ngFor="let briefanrede of briefAnredenAbgefuellt" [value]="briefanrede.briefanrede" >
            {{ briefanrede.briefanrede }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.titel" | translate }}</mat-label>
        <input matInput formControlName="fldAdresstitel" />
      </mat-form-field>
    </span>

    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.zusatz" | translate }}</mat-label>
        <input matInput formControlName="fldAdressZusatz" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.strasse" | translate }}</mat-label>
        <input matInput formControlName="fldAdressStrasse" />
      </mat-form-field>
    </span>

    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.plz" | translate }}</mat-label>
        <input matInput formControlName="fldAdressPlz" (keyup)="onZIPChange($event)" required />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.ort" | translate }}</mat-label>
        <input matInput formControlName="fldAdressOrt" required />
      </mat-form-field>
    </span>

    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.mobile" | translate }}</mat-label>
        <input matInput formControlName="fldAdressMobile" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.telefon" | translate }}</mat-label>
        <input matInput formControlName="fldAdressTelefon" />
      </mat-form-field>
    </span>

    <span class="row">
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.email" | translate }}</mat-label>
        <input matInput formControlName="fldAdressEmail" />
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ "MAIN_APP_ADRESSES.homepage" | translate }}</mat-label>
        <input matInput formControlName="fldAdressHomepage" />
      </mat-form-field>
    </span>
  </mat-card-content>

  <mat-dialog-actions>
	  <button (click)="save()" [disabled]="!formGroupAdresse.valid" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-stroked-button></button>
    <button mat-stroked-button class="cancel" mat-dialog-close [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate"></button>
  </mat-dialog-actions>
</mat-card>
